import { __rest } from "tslib";
import * as React from "react";
import { forwardRef } from "react";
import clsx from 'clsx';
const _MoonIcon = (_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement("svg", Object.assign({ fill: "currentColor", viewBox: "0 0 10 14", role: "presentation", width: 16, height: 16, className: clsx("cmp-icon", className), ref: ref }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M6.576 2a5.015 5.015 0 0 0 0 10A6.337 6.337 0 0 1 4.14 7c0-2.031.954-3.839 2.437-5ZM.611 7A6.348 6.348 0 0 1 8.71.897c.743.213.655 1.17.049 1.393a5.017 5.017 0 0 0 0 9.42c.606.222.694 1.18-.048 1.393A6.348 6.348 0 0 1 .61 7Z", clipRule: "evenodd" }));
};
const MoonIcon = forwardRef(_MoonIcon);
export default MoonIcon;
//# sourceMappingURL=moon.js.map